import memoize from './memoize'

const ensureIframe = memoize(() => {
  return document.createElement('iframe')
})

export const checkIFrameHasSandbox = () => {
  const iframe = ensureIframe()
  return 'sandbox' in iframe
}

export const isMobile = () => {
  const UA = navigator.userAgent
  return (
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
  )
}
